import React from 'react';
import { Globe } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ onContactClick }) => {
  return (
    <header className="bg-white py-4 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Language Selector */}
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <img src="https://flagcdn.com/w20/us.png" alt="US" className="w-5 h-4" />
            <span>EN</span>
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>

          {/* Logo */}
          <div className="flex items-center space-x-3">
            <Globe className="w-10 h-10 text-[#8B1538]" strokeWidth={1.5} />
            <span className="text-[#1a3a5c] font-semibold text-lg tracking-wide hidden sm:block">
              US PROFESSIONAL IMMIGRATION
            </span>
          </div>

          {/* CTA Button */}
          <Button
            onClick={onContactClick}
            className="bg-[#c94a4a] hover:bg-[#b33d3d] text-white px-6 py-2 rounded font-medium transition-colors"
          >
            Contact Us Now
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
